import React, { useState, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, DeleteChildDialog, Icon, Input, Layout, Password, Toast, Dialog } from "@app/components";
import {
  Error,
  EmptyContainer,
  DefaultMessage
} from "@app/components/commonStyles";
import { useParams, useLocation } from 'react-router-dom'
import { emailPattern, gradesList, subjectOptions } from "@app/utils";
import { faEye, faEyeSlash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonContainer, ActionsHolder, StudentDetailsWrapper, StudentDetailWrapper, StudentTableColumn, StudentTableContent, StudentTableContentHolder, StudentTableHeader, StudentTableWrapper, StudentsTableWrapper } from "./educator-component";
import { PopUpContainer, PopUpSubTitle, PopUpText, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";
import RemoveIcon from "@app/components/icon/icons/remove-icon";
import { AuthContext } from "@app/providers";
import { getClassroom, deleteStudent, addStudent, validateEmail, resetStudentPassword, showStudentPassword } from "@app/services";
import { useHistory } from "react-router-dom";
import { GoogleSVG, AddStudentPNG } from "@app/assets";
import "./css/print-student.css";

export default function ListStudents() {  
  let { id }: any = useParams()
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [addStudentDetails, showAddStudentDetails] = useState(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [deleteText, setDeleteText] = useState<string>("Remove");
  const { userInfo }: any = useContext(AuthContext);
  const userToken = userInfo && userInfo.sessionToken;
  const [studentsList, setStudentsList] = useState<any>([]);
  const [totalStudent, setTotalStudents] = useState<any>([]);
  const [studentPassword, setStudentPassword] = useState<any>({
    password: "",
    key: ""
  });
  const [showPasswordField, setShowPasswordField] = useState<boolean>(false);
  const [showPasswordButton, setShowPasswordButton] = useState<boolean>(true);
  const [spinner, setSpinner] = useState(false)
  const [classRoomDetails, showClassRoomDetails] = useState<any>()
  const [studentId, setStudentId] = useState()
  const [existStudent, showExistErr] = useState(false)
  const [noStudents, showNoStudents] = useState(false)
  const [removeEmptyInput, setRemoveEmptyInput] = useState(false)
  const [showToast, setShowToast] = React.useState(false);
  const [submitText, setSubmitText] = useState<string>("Add Google Students");
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  let history = useHistory();

  const { trigger, register, handleSubmit, errors, getValues }: any = useForm({});
  const [students, addStudents] = useState<any>([])
  const [maxStudentErr, showMaxStudentErr] = useState(false)
  const [addStudentPopup, showAddStudentPopup] = useState<boolean>(false)
  const [activeInput, showActiveInput] = useState<boolean>(false)
  const [maxStudents, setMaxStudents] = useState<any>()
  const [readMoreUnable, setReadMoreUnable] = useState(true)
  const location = useLocation();
  const pathData = location.pathname.split('/');
  const [returnData, setReturnData] = useState<boolean>(false)
  const [respErr, setRespErr] = useState<any>();
  const base64 = require('base-64')

  useEffect(() => {
    if (!userToken) {
      history.replace("/sign-in")
    }

    if ((userInfo && userInfo.userJson.userType === "parent" || userInfo && userInfo.userJson.userType === "student") && pathData[1] === "add-students") {
      history.replace('/pagenotfound')
    }
    if (userInfo && userInfo.userJson.userType === "educator") {
      getClassroomDetails()
    }
  }, [])

  const getClassroomDetails = () => {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo && userInfo.sessionToken,
      userId: userInfo && userInfo.userJson.userId,
      classRoomId: id,
      studentsDataFlag: true
    });
    setSpinner(true)

    getClassroom(params)
      .then((resp: any) => {
        const response = resp;
        if (response._responseStatus === 1) {
          setReturnData(true)
          showClassRoomDetails(response.allClassroomsDocs[0])  
          setStudentsList(response.allClassroomsDocs[0].studentData)
          setTotalStudents(response.allClassroomsDocs[0].noOfStudents)
          showNoStudents(response.allClassroomsDocs[0].studentData.length)
          let count = parseInt(response.allClassroomsDocs[0].noOfStudents)
          setMaxStudents(count)
          setSpinner(false)
          if (response.allClassroomsDocs[0].studentIds === '') {
            showActiveInput(true)
          }
        } else {
          setRespErr(resp.msg)
          setReturnData(false)
          setSpinner(false)
        }
      })
  }

  const [formValues, setFormValues] = useState<any>([])
  function totalStudents() {
    let values = getValues()
    setFormValues(values.students)
  }

  const handlePrint = () => {
    window.print();
  }
  
  return (
    <>
      <Layout classRoomLayout={true} className="print-responsive">
        <form className="form-center">
          {returnData && studentsList && classRoomDetails && !addStudentPopup ?
            <h2 className="primary-header label-color text-center mb-3">Classroom students details</h2> : ''
          }

          {returnData && studentsList && classRoomDetails?
            <div>
              <span className="classname-label">Classroom name:
                <span className="classname-value">{classRoomDetails.classRoomName}</span>
              </span>
              <span className="teachername-label">Teacher name:
                <span className="teachername-value">{classRoomDetails.teacherName}</span>
              </span>
            </div>
             : ''
          }
          <div>
          {returnData && studentsList && <h4 className="secondary-header mb-3">Students ({studentsList.length} of {totalStudent})</h4>}
          </div>

          <StudentsTableWrapper>
            <table className="list-student-table">
              <thead style={{textAlign:"left"}}>
                <tr>
                  <th className="w-150">First Name</th>
                  <th className="w-150">Last Name</th>
                  <th className="w-150">Username</th>
                  <th className="w-150">Password</th>
                </tr>
              </thead>
              <tbody>
                {studentsList && studentsList.map((student: any, index: any) => {
                  if (student) {
                    return (
                      <tr>
                        <td className="w-150">{student.firstName}</td>
                        <td className="w-150">{student.lastName}</td>
                        <td className="w-150">{student.email}</td>
                        <td className="w-150">{student.password}</td>
                      </tr>
                    )
                  }
                })}
                {spinner &&
                  <EmptyContainer>
                    <Icon name="loader" />
                    <DefaultMessage>Loading, please wait...</DefaultMessage>
                  </EmptyContainer>
                }
                {returnData && studentsList.length === 0 && students.length === 0 && spinner === false &&
                  <EmptyContainer>
                    <DefaultMessage className="mb-2 small-font">No Students added yet in the Classroom</DefaultMessage>
                  </EmptyContainer>
                }

              </tbody>
            </table>
            {maxStudentErr && <p>Max no.of students exceded</p>}
          </StudentsTableWrapper>
          {/* Print icon */}
          <button onClick={handlePrint} className="print-btn">
            <span>Print</span>
          </button>
          <button className="print-btn" onClick={() => history.replace("/classrooms")}>Cancel</button>
        </form>
      </Layout>
    </>
  );
}
